__turbopack_context__.v({
  "aboutbox1": "upsc-interview-module__1jgCra__aboutbox1",
  "acheivername": "upsc-interview-module__1jgCra__acheivername",
  "acheiverrank": "upsc-interview-module__1jgCra__acheiverrank",
  "acheiverscrollparent": "upsc-interview-module__1jgCra__acheiverscrollparent",
  "bgbox": "upsc-interview-module__1jgCra__bgbox",
  "bground": "upsc-interview-module__1jgCra__bground",
  "bluetxt": "upsc-interview-module__1jgCra__bluetxt",
  "bluetxt1": "upsc-interview-module__1jgCra__bluetxt1",
  "btnbox": "upsc-interview-module__1jgCra__btnbox",
  "btnbox1": "upsc-interview-module__1jgCra__btnbox1",
  "captcha": "upsc-interview-module__1jgCra__captcha",
  "checkboxcontent": "upsc-interview-module__1jgCra__checkboxcontent",
  "civilisationcontent": "upsc-interview-module__1jgCra__civilisationcontent",
  "contactheader": "upsc-interview-module__1jgCra__contactheader",
  "customFileUploader": "upsc-interview-module__1jgCra__customFileUploader",
  "dot": "upsc-interview-module__1jgCra__dot",
  "downloadicon": "upsc-interview-module__1jgCra__downloadicon",
  "facultyborder1": "upsc-interview-module__1jgCra__facultyborder1",
  "formstar": "upsc-interview-module__1jgCra__formstar",
  "input-group-btn": "upsc-interview-module__1jgCra__input-group-btn",
  "interviewbg": "upsc-interview-module__1jgCra__interviewbg",
  "invalidCheck2": "upsc-interview-module__1jgCra__invalidCheck2",
  "mobtxt": "upsc-interview-module__1jgCra__mobtxt",
  "normalbutton": "upsc-interview-module__1jgCra__normalbutton",
  "ourachievementcontent": "upsc-interview-module__1jgCra__ourachievementcontent",
  "pagemaintitle": "upsc-interview-module__1jgCra__pagemaintitle",
  "redbtn": "upsc-interview-module__1jgCra__redbtn",
  "redbtn1": "upsc-interview-module__1jgCra__redbtn1",
  "redunderlinealink": "upsc-interview-module__1jgCra__redunderlinealink",
  "scrolldiv": "upsc-interview-module__1jgCra__scrolldiv",
  "scrollparent": "upsc-interview-module__1jgCra__scrollparent",
  "sectionsubtitle": "upsc-interview-module__1jgCra__sectionsubtitle",
  "sectiontitle": "upsc-interview-module__1jgCra__sectiontitle",
  "selected": "upsc-interview-module__1jgCra__selected",
});
